module.exports = __webpack_public_path__ + "static/media/PC_grey.fb9f7d54.svg";